<template>
    <rkm-data-table
        :fields="fields"
        :repository="repositories.salaVacinacao"
        ref="RkmDataTable"
        sort-by="unidadeNome"
    >
        <template v-slot:cell(actions)="row">
            <rkm-button
                @click="handleEdit(row.item.id)"
                authorize="update-imunizacao-sala-vacinacao"
                color="primary"
                small
                title="Editar"
            >
                <rkm-icon icon="pen" />
            </rkm-button>

            <rkm-button
                v-if="row.item.ativo"
                @click="handleDestroy(row.item)"
                authorize="destroy-imunizacao-sala-vacinacao"
                color="dark"
                small
                title="Inativar"
            >
                <rkm-icon icon="ban" />
            </rkm-button>

            <rkm-button
                v-else
                @click="handleDestroy(row.item)"
                authorize="destroy-imunizacao-sala-vacinacao"
                color="success"
                small
                title="Ativar"
            >
                <rkm-icon icon="check-circle" />
            </rkm-button>
        </template>
    </rkm-data-table>
</template>

<script>
// Mixins.
import { error, repository } from '@/mixins'

export default {
    computed: {
        fields() {
            return [
                { key: 'unidadeNome', label: 'Unidade', name: 'cadastroUnidade.nomeFantasia', searchable: true, sortable: true },
                { key: 'infraestruturaNome', label: 'Local de atendimento', name: 'cadastroInfraestrutura.nome', searchable: true, sortable: true },
                { key: 'responsavel', label: 'Responsável', name: 'imunizacaoSalaVacinacao.responsavel', searchable: true, sortable: true },
                { key: 'permiteAplicacao', label: 'Permitir aplicação', name: 'imunizacaoSalaVacinacao.permiteAplicacao', searchable: true, sortable: true },
                { key: 'permiteRequisicao', label: 'Permitir requisição', name: 'imunizacaoSalaVacinacao.permiteRequisicao', searchable: true, sortable: true },
                { class: 'col-min text-center', key: 'actions', label: 'Ações' },
            ]
        },
    },
    created() {
        this.repositories = {
            salaVacinacao: this.getConectaSusRepository('imunizacao.salaVacinacao')
        }
    },
    methods: {
        handleEdit(id) {
            this.$router.push({ name: 'imunizacao-sala-vacinacao-edit', params: { id: id } })
        },
        handleDestroy(item) {
            const destroy = () => this.repositories.salaVacinacao.destroy(item.id)
                .then(() => this.$refs.RkmDataTable.refresh())

            if (item.ativo) {
                this.createNotification({
                    color: 'danger',
                    confirm: destroy,
                    message: 'Deseja realmente inativar a sala de vacinação?',
                    onError: this.handleError,
                    title: 'Confirmação de inativação',
                    type: 'dialog',
                })
            } else {
                this.createNotification({
                    color: 'success',
                    confirm: destroy,
                    message: 'Deseja realmente ativar a sala de vacinação?',
                    onError: this.handleError,
                    title: 'Confirmação de ativação',
                    type: 'dialog',
                })
            }
        },
    },
    mixins: [ error, repository ],
}
</script>